import type { RentalTemplateContextConfig } from "#lib/web-ui/rental/index.js";
import { villasSiteConfig } from "#lib/constants/villas-site-config.js";
import { parkwoodSiteConfig } from "#lib/constants/parkwood-site-config.js";
import { domainRouting, displaySiteKeys, type DisplaySite } from "@fergmar/config/domain-routing";

// Pure routing data + derived origins live in @fergmar/config/domain-routing (no `#lib`/`$app/env`)
// so plain Node code can import the origin lists. siteConfig objects are attached
// here because they pull in `$app/env` via the site configs.
export { displaySiteKeys, type DisplaySite } from "@fergmar/config/domain-routing";
export { corsProdOrigins, isDevOrigin } from "@fergmar/config/domain-routing";
// Backward-compat alias: the routing map (without siteConfig, which is attached
// per-call by getDomainEntry). Consumers that need siteConfig use getDomainEntry.
export { domainRouting as domainMap } from "@fergmar/config/domain-routing";

/** Rental-template site config per domain key (null for non-rental sites). */
const siteConfigByKey: Record<DisplaySite, RentalTemplateContextConfig | null> = {
	"app.fergmar.com": null,
	"go.fergmar.com": null,
	"fergmar.com": null,
	"fergmarcapital.com": null,
	"fergmarproperties.com": null,
	"brand.fergmar.com": null,
	"thevillastx.com": villasSiteConfig,
	"liveatparkwood.com": parkwoodSiteConfig,
	"fergmarhomebuyers.com": null
};

/**
 * Returns the routing entry for a hostname, augmented with its siteConfig
 * (same shape consumers relied on when the map embedded siteConfig inline),
 * or null if not found.
 */
export function getDomainEntry(hostname: string) {
	for (const key of displaySiteKeys) {
		const routing = domainRouting[key];
		if (routing.entry.some((entryDomain) => hostname === entryDomain)) {
			return { ...routing, siteConfig: siteConfigByKey[key] };
		}
	}
	return null;
}
